<ng-template #alertTemplate>
  {{ 'shared:error.email-service.not_configured' | i18next }}
  <a [routerLink]="'/AP/EmailService'">{{'shared:buttons.configure_here' | i18next }}</a>
</ng-template>
